// trygg inline rendering
export const renderValueSafeInline = (v) => {
  if (v === null || v === undefined) return "-";
  if (typeof v === "string" || typeof v === "number" || typeof v === "boolean")
    return String(v);
  if (Array.isArray(v)) {
    if (v.length === 0) return "-";
    const primitives = v.every((x) =>
      ["string", "number", "boolean"].includes(typeof x)
    );
    return primitives
      ? v.join(", ")
      : v
          .map((x) => (typeof x === "object" ? JSON.stringify(x) : String(x)))
          .join(", ");
  }
  if (typeof v === "object") {
    const entries = Object.entries(v);
    if (entries.length === 0) return "-";
    const allPrimitives = entries.every(
      ([, val]) =>
        val === null || ["string", "number", "boolean"].includes(typeof val)
    );
    if (allPrimitives)
      return entries.map(([k, val]) => `${k}: ${val ?? "-"}`).join(", ");
    try {
      return JSON.stringify(v);
    } catch {
      return "[object]";
    }
  }
  return String(v);
};
